import http from './http.service';

class AccommodationPlaceService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/accommodationPlace";
    }

    getForEvent(eventId) {
        if (!eventId) {
            throw new Error('EventId is required');
        }

        return this.$http.post(`${this.baseUrl}/getForEvent`, { eventId: eventId });
    };
}

export default new AccommodationPlaceService();
